// extracted by mini-css-extract-plugin
module.exports = {"whyDetailsSection":"why-details_whyDetailsSection__uxD4d"};